import { Link, useNavigate } from "react-router-dom";
import {
  CONTACTUS_URL_LOCAL,
  HOME_URL_LOCAL,
  RETURNURLLOGIN_URL_LOCAL,
} from "../../utility/BaseUrl";
import { useState } from "react";
import { isTokenValid } from "../../utility/Cookies";
import Swal from "sweetalert2";
import { ContactUsService } from "../../services/MainScreen";

export default function ContactUs() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({ title: "", description: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleValidation = () => {
    const newErrors = {};
    if (!title.trim()) {
      newErrors.title = "عنوان را وارد کنید";
    }
    if (!description.trim()) {
      newErrors.description = "متن را وارد کنید";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (handleValidation()) {
      if (isTokenValid()) {
        let res = await ContactUsService(title, description);
        setTitle("");
        setDescription("");

        if (res.status === 200)
          Swal.fire({
            icon: "success",
            text: res.message,
            confirmButtonText: "فهمیدم",
          });
        else
          Swal.fire({
            icon: "warning",
            text: res.message,
            confirmButtonText: "باشه",
          });
      } else
        Swal.fire({
          icon: "info",
          text: "شما اول باید وارد حساب خود شوید!",
          confirmButtonText: "ورود به حساب",
          showCancelButton: true,
          cancelButtonText: "لغو",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(RETURNURLLOGIN_URL_LOCAL(CONTACTUS_URL_LOCAL));
          }
        });
    }
    setLoading(false);
  };

  return (
    <>
      <main className="page-container form-container form-asidecontent-container mt-4">
        <div className="container">
          <div className="page-context form-context form-asidecontent-context">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={HOME_URL_LOCAL} className="text-muted">
                  <span className="d-flex align-items-center">
                    <i
                      className="fa fa-home text-primary breadcrumb-home-icon d-inline-flex ml-10 position-relative text-xl"
                      aria-hidden="true"
                    />
                    خانه
                  </span>
                </Link>
              </li>
              <li className="breadcrumb-item active">
                <span>ارتباط با ما</span>
              </li>
            </ol>
            <h1 className="page-title form-title form-asidecontent-title mb-3">
              ارتباط با ما
            </h1>
            <hr className="page-separator form-separator form-asidecontent-separator d-none d-md-block" />
            <div className="row flex-row-reverse">
              <div className="col-12 col-md-6 pr-md-20">
                <div className="page-description form-description form-asidecontent-description break-word text-sm pt-md-30">
                  <p>
                    <span style={{ color: "rgb(0, 0, 0)" }}>
                      <strong style={{ fontWeight: 700 }}>
                        <span style={{ fontSize: 18 }}>
                          📥 سوالات، انتقادات و پیشنهادات خود را از طریق این فرم
                          با ما در میان بگذارید.
                        </span>
                      </strong>
                    </span>
                  </p>
                  <p>
                    <span style={{ color: "rgb(0, 0, 0)" }}>
                      <strong style={{ fontWeight: 700 }}>
                        <span style={{ fontSize: 18 }}>
                          💬 جهت استفاده حتما در سیستم وارد شوید!
                        </span>
                      </strong>
                    </span>
                  </p>
                  {/* <p>
                    <span style={{ color: "rgb(0, 0, 0)" }}>
                      <strong style={{ fontWeight: 700 }}>
                        <span style={{ fontSize: 18 }}>
                          ☎️ شماره تماس ثابت : 02538832063{" "}
                        </span>
                      </strong>
                      <span style={{ fontSize: 18 }}>
                        <br />
                      </span>
                      <span style={{ fontSize: 14 }}>
                        <strong>
                          (ساعت پاسخگویی از ۱۱ الی ۱۸ بجز روزهای تعطیل)
                        </strong>
                      </span>
                    </span>
                  </p>
                  <p>
                    <span style={{ color: "rgb(0, 0, 0)" }}>
                      <strong style={{ fontWeight: 700 }}>
                        <span style={{ fontSize: 18 }}>
                          💬 پشتیبانی پیامکی : 09900560027{" "}
                        </span>
                      </strong>
                      <span style={{ fontSize: 18 }}>
                        <br />
                      </span>
                      <span style={{ fontSize: 14 }}>
                        <strong>
                          (پاسخگویی فقط از طریق پیام در واتساپ، تلگرام و ایتا)
                        </strong>
                      </span>
                    </span>
                  </p>
                  <p>
                    <strong style={{ fontWeight: 700 }}>
                      <span style={{ color: "rgb(0, 0, 0)", fontSize: 18 }}>
                        📍 آدرس: قم، میدان توحید، رو به روی بانک ملت، پلاک 155،
                        انبار مرکزی اکو
                      </span>
                    </strong>
                    <span style={{ color: "rgb(0, 0, 0)", fontSize: 18 }}>
                      <strong style={{ fontWeight: 700 }}>کوثر </strong>
                      <br />
                    </span>
                    <span style={{ color: "rgb(0, 0, 0)", fontSize: 14 }}>
                      <strong>
                        (آدرس فوق صرفا انبار ارسالی کالا است و امکان مراجعه
                        حضوری را ندارد)
                      </strong>
                    </span>
                  </p>
                  <p>
                    <br />
                  </p> */}
                </div>
                <hr className="page-separator form-separator form-asidecontent-separator d-block d-md-none" />
              </div>
              <div className="col-12 col-md-6 pl-md-20">
                <form
                  name="formbuilder"
                  className="form-asidecontent-element"
                  onSubmit={handleSubmit}
                >
                  <div className="form-group form-text form-asidecontent-text name">
                    <label className="form-text-label form-asidecontent-text-label">
                      عنوان
                    </label>
                    <input
                      type="text"
                      className="form-control form-asidecontent-text-input"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                    {errors.title && (
                      <div className="validation-inline form-asidecontent-inline-error text-danger">
                        <span>{errors.title}</span>
                      </div>
                    )}
                  </div>

                  <div className="form-group form-textarea form-asidecontent-textarea description">
                    <label className="form-textarea-label form-asidecontent-textarea-label">
                      پیام
                    </label>
                    <textarea
                      rows={5}
                      className="form-control form-asidecontent-textarea-input"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                    {errors.description && (
                      <div className="validation-inline form-asidecontent-inline-error text-danger">
                        <span>{errors.description}</span>
                      </div>
                    )}
                  </div>
                  <hr className="form-hr form-asidecontent-hr" />
                  <div className="form-group mb-0">
                    <button
                      type="submit"
                      className="rounded btn btn-lg btn-primary form-submit form-asidecontent-submit"
                    >
                      ارسال
                    </button>
                    <div
                      className={
                        "form-loading form-asidecontent-loading" +
                        (loading ? "" : " d-none")
                      }
                    >
                      <i className="fa fa-refresh fa-spin fa-fw" />
                      کمی صبر کنید...
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
